


































import Vue from 'vue'
import Component from "vue-class-component";
import { Prop, Ref } from 'vue-property-decorator';
import {Action} from "vuex-class";
import { getErrorMessage } from '@/utils/notify-helper';
import GoogleCaptcha from '@/components/reCAPTCHA';

@Component({components: {GoogleCaptcha}})
export default class registrationEmailForm extends Vue {
  @Ref('validator') validator:any;
  @Prop() email!: string;
  @Prop() sitekey!: string;

  @Action("regCodeSend") actionRequest: any;

  private form = {
    email: '',
    googleToken: ''
  }

  async submit() {
    this.$emit('errorMessage', undefined)
    if (!await this.validator.validate()) {
      return
    }

    //@ts-ignore
    this.form.googleToken = await this.$refs.captcha.generateToken();

    this.$emit('isProgress', true)
    try {
      const resp = await this.actionRequest(this.form);
      if (resp.data.success) {
        this.$emit('email', this.form.email)
        this.$emit('form', 'registrationCodeForm')
      } else {
        this.$emit('errorMessage', this.$t('errors.captcha_failed'))
      }
    } catch (e) {
      const errorMessage = getErrorMessage(e)
      this.$emit('errorMessage', errorMessage)
    } finally {
      this.$emit('isProgress', false)
    }
  }

}
